import dayjs from 'dayjs';
import { minBy, range } from 'lodash-es';
import type { LowPrices } from '@aviata/platform-client';

type Search = {
  price: string;
  search_date: string;
};

const getRangeBorders = (current: string, defaultRange: number) => {
  const today = dayjs();

  let rangeLeftBorder = -defaultRange;
  let rangeRightBorder = defaultRange + 1;

  const currentFromDate = dayjs(current).add(rangeLeftBorder, 'd');
  const currentToDate = dayjs(current).add(rangeRightBorder, 'd');

  const leftDateBorder = today;
  const rightDateBorder = dayjs(today).add(360, 'd');

  if (dayjs(currentToDate).isAfter(rightDateBorder)) {
    const daysAfterBorder = currentToDate.diff(rightDateBorder, 'day');
    rangeLeftBorder -= daysAfterBorder;
    rangeRightBorder -= daysAfterBorder;
  } else if (dayjs(currentFromDate).isBefore(leftDateBorder)) {
    const daysBeforeBorder = leftDateBorder.diff(currentFromDate, 'day');
    rangeLeftBorder += daysBeforeBorder;
    rangeRightBorder += daysBeforeBorder;
  }

  return [rangeLeftBorder, rangeRightBorder];
};

const createDateRange = (current: string, defaultRange: number) => {
  const [rangeFrom, rangeTo] = getRangeBorders(current, defaultRange);

  return range(rangeFrom, rangeTo).flatMap(n => {
    const date = dayjs(current).add(n, 'd');
    return date.format('YYYY-MM-DD');
  });
};

const getLowestPrice = (searches: Search[]) => {
  return minBy(searches, search => Number(search.price))?.price;
};

export const mapSearches = (
  searches: LowPrices.CalendarResponse,
  selectedDate: string,
  defaultRange: number,
) => {
  const minPrice = getLowestPrice(
    Object.values(searches).filter(search => search !== null),
  );

  const departureDates = createDateRange(selectedDate, defaultRange);

  return departureDates.map((date, ind) => {
    const searchData = searches[date];
    return {
      id: ind,
      departureDate: date,
      isActive: date === selectedDate,
      isMinPrice: Boolean(minPrice && searchData?.price === minPrice),
      price: searchData ? parseInt(searchData.price, 10) : null,
    };
  });
};

export const getDateRangeForGetRequest = (
  selectedDate: string,
  defaultRange: number,
) => {
  const today = dayjs();

  const leftBorderDate = dayjs(selectedDate).subtract(defaultRange, 'd');
  const daysBeforeLeftBorder = today.diff(leftBorderDate, 'day');

  if (daysBeforeLeftBorder > 0) {
    return defaultRange + daysBeforeLeftBorder;
  }
  return defaultRange;
};
